(function () {
    const API_REVISION = "2024-06-15";

    function getConfig() {
        return window.klaviyoBisModalConfig || null;
    }

    function parseVariant(el) {
        return {
            id: el.dataset.variantId,
            title: el.dataset.variantTitle || el.dataset.variantId,
            inventory: parseInt(el.dataset.variantInventoryQty, 10),
            stockLimit: parseInt(el.dataset.variantStockLimit, 10),
            inventoryManagement: el.dataset.variantInventoryManagement || "",
            available: el.dataset.variantAvailable,
        };
    }

    function isNotifyVariant(variant) {
        if (variant.available !== "true") {
            return true;
        }

        if (
            !Number.isNaN(variant.inventory) &&
            !Number.isNaN(variant.stockLimit) &&
            variant.inventory <= variant.stockLimit
        ) {
            return true;
        }

        if (
            variant.inventoryManagement !== "" &&
            variant.inventory <= 0 &&
            variant.inventory > variant.stockLimit
        ) {
            return true;
        }

        return false;
    }

    function getNotifyVariants(productForm) {
        if (!productForm) {
            return [];
        }

        return Array.from(productForm.querySelectorAll(".product-variant"))
            .map(parseVariant)
            .filter(isNotifyVariant);
    }

    function getSelectedVariantId(trigger) {
        const fromTrigger = trigger.getAttribute("data-variant-id");
        if (fromTrigger) {
            return fromTrigger;
        }

        const productForm = trigger.closest("[data-product-form]");
        const variantField = productForm && productForm.querySelector('[name="id"]');
        return variantField ? variantField.value : null;
    }

    function buildVariantCompositeId(variantId) {
        return "$shopify:::$default:::" + variantId;
    }

    function isValidEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function KlaviyoBisModal() {
        this.modal = document.getElementById("ns-klaviyo-bis-modal");
        if (!this.modal) {
            return;
        }

        this.backdrop = this.modal.querySelector(".ns-klaviyo-bis-modal__backdrop");
        this.form = this.modal.querySelector(".ns-klaviyo-bis-modal__form");
        this.variantRow = this.modal.querySelector(".ns-klaviyo-bis-modal__variant-row");
        this.variantSelect = this.modal.querySelector("#ns-klaviyo-bis-variant");
        this.emailInput = this.modal.querySelector("#ns-klaviyo-bis-email");
        this.submitButton = this.modal.querySelector(".ns-klaviyo-bis-modal__submit");
        this.errorMessage = this.modal.querySelector(".ns-klaviyo-bis-modal__error");
        this.successMessage = this.modal.querySelector(".ns-klaviyo-bis-modal__success");
        this.headline = this.modal.querySelector(".ns-klaviyo-bis-modal__headline");
        this.bodyContent = this.modal.querySelector(".ns-klaviyo-bis-modal__body");
        this.footerContent = this.modal.querySelector(".ns-klaviyo-bis-modal__footer");
        this.activeTrigger = null;

        this.bindEvents();
    }

    function isTriggerVisible(trigger) {
        return trigger.offsetWidth > 0 || trigger.offsetHeight > 0;
    }

    function initKlaviyoBisModal() {
        const config = getConfig();
        if (config && config.copy && config.copy.buttonLabel) {
            document.querySelectorAll(".klaviyo-bis-trigger").forEach(function (trigger) {
                trigger.textContent = config.copy.buttonLabel;
            });
        }

        window.nsKlaviyoBisModal = new KlaviyoBisModal();
    }

    KlaviyoBisModal.prototype.bindEvents = function () {
        const self = this;

        document.addEventListener("click", function (event) {
            const trigger = event.target.closest(".klaviyo-bis-trigger");
            if (!trigger || !isTriggerVisible(trigger)) {
                return;
            }

            event.preventDefault();
            event.stopImmediatePropagation();
            self.open(trigger);
        }, true);

        this.modal.addEventListener("click", function (event) {
            if (
                event.target.closest(".ns-klaviyo-bis-modal__close") ||
                event.target.closest(".ns-klaviyo-bis-modal__success-close")
            ) {
                event.preventDefault();
                self.close();
            }
        });

        this.backdrop.addEventListener("click", function () {
            self.close();
        });

        document.addEventListener("keydown", function (event) {
            if (event.key === "Escape" && self.modal.classList.contains("is-open")) {
                self.close();
            }
        });

        this.form.addEventListener("submit", function (event) {
            event.preventDefault();
            self.submit();
        });
    };

    KlaviyoBisModal.prototype.resetState = function () {
        this.errorMessage.hidden = true;
        this.successMessage.hidden = true;
        this.form.hidden = false;
        this.headline.hidden = false;
        this.bodyContent.hidden = false;
        this.footerContent.hidden = false;
        this.modal.classList.remove("is-success");
        this.submitButton.disabled = false;
        this.errorMessage.textContent = "";
    };

    KlaviyoBisModal.prototype.showSuccessState = function () {
        this.form.hidden = true;
        this.headline.hidden = true;
        this.bodyContent.hidden = true;
        this.footerContent.hidden = true;
        this.successMessage.hidden = false;
        this.modal.classList.add("is-success");
    };

    KlaviyoBisModal.prototype.open = function (trigger) {
        const config = getConfig();
        if (!config) {
            return;
        }

        const productForm = trigger.closest("[data-product-form]");
        const variants = getNotifyVariants(productForm);

        if (!variants.length) {
            return;
        }

        this.activeTrigger = trigger;
        this.resetState();

        this.headline.textContent = config.copy.headline.replace("{product_name}", config.productTitle);
        this.bodyContent.innerHTML = config.copy.bodyContent.replace("{product_name}", config.productTitle);
        this.footerContent.innerHTML = config.copy.footerContent;
        this.emailInput.placeholder = config.copy.emailLabel;
        this.submitButton.textContent = config.copy.buttonLabel;
        this.successMessage.innerHTML =
            config.copy.successLabel +
            ' <a href="#" class="ns-klaviyo-bis-modal__success-close">' +
            config.copy.closeLabel +
            "</a>";

        this.variantSelect.innerHTML = "";
        variants.forEach(function (variant) {
            const option = document.createElement("option");
            option.value = variant.id;
            option.textContent = variant.title;
            this.variantSelect.appendChild(option);
        }, this);

        const selectedVariantId = getSelectedVariantId(trigger);
        if (selectedVariantId && variants.some(function (v) { return v.id === selectedVariantId; })) {
            this.variantSelect.value = selectedVariantId;
        }

        this.variantRow.hidden = variants.length <= 1;
        this.emailInput.value = config.customerEmail || "";

        this.modal.classList.add("is-open");
        document.body.classList.add("ns-klaviyo-bis-modal-open");
        this.emailInput.focus();
    };

    KlaviyoBisModal.prototype.close = function () {
        this.modal.classList.remove("is-open");
        document.body.classList.remove("ns-klaviyo-bis-modal-open");
        this.activeTrigger = null;
    };

    KlaviyoBisModal.prototype.submit = function () {
        const config = getConfig();
        if (!config) {
            return;
        }

        const email = this.emailInput.value.trim();
        const variantId = this.variantSelect.value;

        if (!isValidEmail(email)) {
            this.errorMessage.textContent = config.copy.errorInvalidEmail;
            this.errorMessage.hidden = false;
            return;
        }

        if (!variantId) {
            this.errorMessage.textContent = config.copy.errorGeneric;
            this.errorMessage.hidden = false;
            return;
        }

        this.submitButton.disabled = true;
        this.errorMessage.hidden = true;

        const payload = {
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: email,
                            },
                        },
                    },
                    channels: ["EMAIL"],
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: buildVariantCompositeId(variantId),
                        },
                    },
                },
            },
        };

        const self = this;

        fetch(
            "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" +
            encodeURIComponent(config.companyId),
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    revision: API_REVISION,
                },
                body: JSON.stringify(payload),
            }
        )
            .then(function (response) {
                if (response.status === 202) {
                    self.showSuccessState();
                    return null;
                }

                return response.json().catch(function () {
                    return null;
                }).then(function (body) {
                    let message = config.copy.errorGeneric;
                    if (body && body.errors && body.errors.length) {
                        message = body.errors[0].detail || message;
                    }
                    throw new Error(message);
                });
            })
            .catch(function (error) {
                self.errorMessage.textContent = error.message || config.copy.errorGeneric;
                self.errorMessage.hidden = false;
                self.submitButton.disabled = false;
            });
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initKlaviyoBisModal);
    } else {
        initKlaviyoBisModal();
    }
})();
